// @ts-nocheck
import PropTypes from "prop-types";
import { useState } from "react";
import { CustomIconButton } from "../Custom/CustomIconButton";
import { BiFilterAlt } from "react-icons/bi";
import { Box } from "@mui/system";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { Menu, MenuItem, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";

export default function ContractorFilter({
  onChange,
  onClear,
  value,
  filterByOptions,
  iconSize,
}) {
  const [anchorMenu, setAnchorMenu] = useState({ status: null });

  function optionClickHandler(item) {
    if (value?.includes(item?.value)) {
      onChange((prev) => [...(prev?.filter((p) => p !== item?.value) || [])]);
    } else {
      onChange((prev) => [...prev, item?.value]);
    }
  }

  function handleCloseAnchorMenu() {
    setAnchorMenu({ status: null });
  }

  function btnClickHandler(e) {
    e.stopPropagation();
    setAnchorMenu({ status: e.currentTarget });
  }

  return (
    <>
      <CustomIconButton
        sx={{
          position: "relative",
          bgcolor: getCssVariableHandler({
            variableName: "--primary-pink-hex",
          }),
          p: "0.35rem",
          "&:hover": {
            bgcolor: getCssVariableHandler({
              variableName: "--primary-pink-hex",
            }),
          },
        }}
        onClick={btnClickHandler}
      >
        {value?.length > 0 ? (
          <Typography
            sx={{
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              top: "-0.35rem",
              right: "-0.35rem",
              borderRadius: "50%",
              p: "0.2rem",
              height: "1.2em",
              border: "1px solid",
              borderColor: getCssVariableHandler({
                variableName: "--white-rgb",
              }),
              aspectRatio: 1,
              bgcolor: getCssVariableHandler({
                variableName: "--primary-pink-hex",
              }),
            }}
          >
            {value?.length}
          </Typography>
        ) : null}
        <BiFilterAlt size={iconSize ?? 28} />
      </CustomIconButton>
      {anchorMenu?.status ? (
        <Menu
          anchorEl={anchorMenu?.status}
          open={Boolean(anchorMenu?.status)}
          onClose={handleCloseAnchorMenu}
          anchorOrigin={{
            horizontal: "right",
            vertical: "bottom",
          }}
          transformOrigin={{
            horizontal: "right",
            vertical: "top",
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "0.5rem !important",
            },
            "& ul": {
              border: `1px solid ${getCssVariableHandler({ variableName: "--primary-pink-hex" })}`,
              overflow: "auto",
              borderRadius: "0.5rem",
            },
            "& li:hover": {
              backgroundColor: getCssVariableHandler({
                variableName: "--primary-pink-hex",
              }),
            },
          }}
        >
          {filterByOptions?.map((item, index) => {
            return (
              <>
                {[0, 6]?.includes(index) && (
                  <Box
                    sx={{
                      marginX: "1rem",
                      paddingBottom: "0.5rem",
                      ...(index == 5
                        ? {
                            paddingTop: "0.5rem",
                            borderTop: "1px solid white",
                            marginTop: "0.5rem",
                          }
                        : {}),
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      {index == 0 ? "Search Filters " : "Filters"}
                    </Typography>
                  </Box>
                )}
                <MenuItem
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "1rem",
                    "&:hover .checkbox-box": {
                      borderColor: "white",
                    },
                  }}
                  key={item?.value}
                  onClick={() => optionClickHandler(item)}
                >
                  {value?.includes(item?.value) ? (
                    <Box
                      className="checkbox-box"
                      sx={{
                        width: "1.7rem",
                        height: "1.7rem",
                        border: "1px solid",
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                        borderRadius: "0.5rem",
                      }}
                    >
                      <Check />
                    </Box>
                  ) : (
                    <Box
                      className="checkbox-box"
                      sx={{
                        width: "1.7rem",
                        height: "1.7rem",
                        border: "1px solid",
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                        borderRadius: "0.5rem",
                      }}
                    ></Box>
                  )}
                  <Typography>{item?.label}</Typography>
                </MenuItem>
              </>
            );
          })}
          <Typography
            onClick={onClear}
            sx={{
              fontSize: "0.8rem",
              px: "1rem",
              width: "100%",
              textAlign: "right",
              cursor: "pointer",
              userSelect: "none",
              "&:hover": {
                textDecoration: "underline",
              },
              "&:active": {
                color: getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                }),
              },
            }}
          >
            clear all
          </Typography>
        </Menu>
      ) : null}
    </>
  );
}

ContractorFilter.propTypes = {
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  value: PropTypes.array,
  filterByOptions: PropTypes.array,
  iconSize: PropTypes.any,
};